import type { ProjectExecute } from "../types/ead-types.js";

const EXPLORE_TYPE_LABELS: Record<string, string> = {
  "pfm-full": "Full PFM map (features and test cases)",
  "pfm-spec": "PFM map with features and functional specs",
  website: "Website exploration and content gathering",
  other: "Custom exploration goal",
};

export function exploreTypeLabel(exploreType?: string): string {
  const key = (exploreType ?? "").trim();
  if (!key) return "PFM discovery (default)";
  return EXPLORE_TYPE_LABELS[key] ?? key;
}

/** Operator-facing markdown shown immediately while the gateway session is still bootstrapping. */
export function buildRunBriefingMarkdown(
  ex: ProjectExecute,
  options?: { templateName?: string; templateDescription?: string },
): string {
  const runName = (ex.name || "this Explore run").trim();
  const templateName = (options?.templateName ?? "").trim();
  const about =
    (ex.description ?? "").trim() || (options?.templateDescription ?? "").trim();
  const target = (ex.targetUrl ?? "").trim() || "the configured target";
  const explore = exploreTypeLabel(ex.exploreType);
  const purpose = ex.runPurpose ?? "live_app_learning";
  const evidence = ex.evidenceSource ?? "live_app";
  const learning =
    ex.contributesToLearning !== false
      ? "will contribute to template learning"
      : "will not update the template learning index";
  const budget = ex.timeBudgetMinutes
    ? `${ex.timeBudgetMinutes} minutes`
    : "not set";
  const aboutBlock = about ? `\n### What this run is about\n\n${about}\n\n` : "";
  const templateLine = templateName ? `- Project template: **${templateName}**\n` : "";

  return (
    `## Run Introduction\n\n` +
    `I have received the assignment for **${runName}** and I am starting now.\n\n` +
    aboutBlock +
    templateLine +
    `- Explore focus: ${explore}\n` +
    `- Purpose: \`${purpose}\`\n` +
    `- Evidence focus: \`${evidence}\`\n` +
    `- Learning mode: ${learning}\n` +
    `- Time budget: ${budget}\n` +
    `- Target: ${target}\n\n` +
    "Phase 1 login: prove the attempt with at least 2 screenshots (ideally 3) in separate " +
    "report_running_step activities before clicking Sign in, then complete login and confirm success.\n\n" +
    "After login is confirmed I will finish initialization and begin PFM discovery. " +
    "I will wait for your messages in chat when you need to steer login or priorities."
  );
}
